import React from 'react'

export default function Title() {
  return (
    <div className='title'>
      <h1>Crud</h1>
    </div>
  )
}
